import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { ElementModel } from 'projects/core/src/lib/models/element.model';
import { ExerciseModel } from 'projects/core/src/lib/models/exercise.model';

@Component({
  selector: 'app-exercise-elements',
  templateUrl: './exercise-elements.component.html',
  styleUrls: ['./exercise-elements.component.scss']
})
export class ExerciseElementsComponent implements OnInit {

  @Input() exercise: ExerciseModel = null;
  @Output() exerciseChange = new EventEmitter<ExerciseModel>();
  @Output() setEdit = new EventEmitter<string>();

  public submitting = false;
  public inOrdering = false;
  public inheritVisible = false;
  private tempOrder: Array<number> = [];

  constructor(
    private router: Router,
    private ui: UiService,
    private auth: AuthStateService,
    private api: ApiService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.ui.setFocus();
  }

  public onNew(): void {
    if (this.exercise !== null && this.auth.hasRight('admin.element.create')) {
      this.router.navigate(['/exercises', this.exercise.id, 'elements', 'new']);
    }
  }

  public exerciseChanged(event: ExerciseModel): void {
    this.exerciseChange.emit(event);
  }

  // sorting

  onStartOrdering(): void {
    if (this.auth.hasRight('admin.element.edit')) {
      this.inOrdering = true;
      this.tempOrder = this.exercise.elements.map((element: ElementModel) => element.id);
      this.setEdit.emit('elements');
    }
  }

  onRowReorder(event: any): void {
    const ids = this.tempOrder.splice(event.dragIndex, 1);
    if (ids && ids.length > 0) {
      this.tempOrder.splice(event.dropIndex, 0, ids[0]);
    }
  }

  onCancel(): void {
    this.inOrdering = false;
    this.setEdit.emit(null);
  }

  onSubmit(): void {
    if (this.exercise !== null) {
      if (this.exercise?.shouldShowInheritDialog()) {
        this.inheritVisible = true;
      } else {
        this.saveOrder(false);
      }
    }
  }

  public saveOrder(inherit: boolean = false): void {
    this.submitting = true;
    const payload = {
      order: this.tempOrder,
      inherit
    };
    this.api.saveElementsOrder(this.exercise.id, payload).subscribe({
      next: (result: any) => {
        this.ui.toastSuccess(this.transloco.translate('exercise_parts.sequence_saved'), this.transloco.translate('common.saved'));
        this.exercise = new ExerciseModel().deserialize(result.data);
        this.exerciseChange.emit(this.exercise);
        this.tempOrder = [];
        this.onCancel();
      },
      error: (error: any) => {
        this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
      }
    }).add(() => {
      this.submitting = false;
    });
  }

}
